import * as React from "react";
import Typography from "@mui/material/Typography";
export const TopoItemContrato = () => {
    return (
        <React.Fragment>
            <Typography
                variant="h5"
                fontFamily={"Co Headline Regular"}
                gutterBottom
                align="left"
                marginLeft="15px"
            >
                Itens do Contrato
            </Typography>
        </React.Fragment>
    );
};
export default TopoItemContrato;
